import React, { FC } from "react";
import styles from "./styles.module.css";

type MenuItemProps = {
  label: string;
  href: string;
  toggleMenu?: () => void;
  isActive?: boolean;
};

const MenuItem: FC<MenuItemProps> = ({ label, href, toggleMenu, isActive }) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    toggleMenu && toggleMenu();
    const id = href.replace("#", "");
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <div className={`${styles.MenuItem} ${isActive && styles.Active}`} onClick={handleClick}>
      {label}
    </div>
  );
};

export default MenuItem;
